<script setup lang="ts">
// import { RouterLink, RouterView } from 'vue-router'
// import HelloWorld from './components/HelloWorld.vue'
import popUpNotif from '@/components/popUpNotif/popUpNotif.vue'
import { baseNotifStore } from '@/stores/notification/baseNotif'
import { popupColorState } from '@/enums/colorStates'

const baseNotif = baseNotifStore()
</script>

<template>
  <popUpNotif
    :label="baseNotif.getNotifLabel"
    :title="baseNotif.getNotifTitle"
    v-if="baseNotif.getErrorNotifState"
    :delay="3000"
    class="mt-[120px]"
    :color-state="popupColorState.DANGER"
  />
  <popUpNotif
    :label="baseNotif.getNotifLabel"
    :title="baseNotif.getNotifTitle"
    v-if="baseNotif.getSuccessNotifState"
    :delay="3000"
    class="mt-[120px]"
    :color-state="popupColorState.PRIMARY"
  />
  <RouterView />
</template>

<style scoped>
header {
  line-height: 1.5;
  max-height: 100vh;
}

.logo {
  display: block;
  margin: 0 auto 2rem;
}

nav {
  width: 100%;
  font-size: 12px;
  text-align: center;
  margin-top: 2rem;
}

nav a.router-link-exact-active {
  color: var(--color-text);
}

nav a.router-link-exact-active:hover {
  background-color: transparent;
}

nav a {
  display: inline-block;
  padding: 0 1rem;
  border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
  border: 0;
}

@media (min-width: 1024px) {
  header {
    display: flex;
    place-items: center;
    padding-right: calc(var(--section-gap) / 2);
  }

  .logo {
    margin: 0 2rem 0 0;
  }

  header .wrapper {
    display: flex;
    place-items: flex-start;
    flex-wrap: wrap;
  }

  nav {
    text-align: left;
    margin-left: -1rem;
    font-size: 1rem;

    padding: 1rem 0;
    margin-top: 1rem;
  }
}
</style>
